export const routeConfig = Object.freeze({
  // Common/Shared Routes
  default: "/",
  login: "/login",
  signin: "/signin",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  signup: "/signup",
  accountVerification: "/account-verification",
  resetLink: "/reset-link",
  resetCompleted: "/reset-completed",
  confirmContactNo: "/confirm-contact-number",
  myProfile: "/my-profile",
  resendVerification: "/generate-email-verification",
  catalogue: "/catalogue",
  pricing: "/pricing",
  addIndividual: "/Add-Individual",
  produtLinsting: "/product-listing",
  manageCatalogue: "/manage-catalogue",
  getNewCartID: "/store/business-setup/",
  shareProductDetails: "/catalogue/share-product/:productId",
  privacyPolicy: "/privacy-policy",

  // Admin User Routes
  adminDashboard: "/admin/dashboard",
  adminSupplierSetupForm: "/admin/users/add-supplier",
  adminBuyerSetupForm: "/admin/users/add-buyer",
  adminAddBuyer: "/admin/users",
  adminAddSupplier: "/admin/add-supplier",
  adminEditSupplier: "/admin/users/add-supplier/:businessId/:supplierEdit",
  adminLevelForm: "/admin/users/add-admin",
  updateAdminLevelForm: "/admin/users/update-admin-form/:adminId",
  adminProductsApprovalSupplier: "/admin-products-approval-supplier",
  algoliaSearch: "/admin/algolia-search",
  addFavourite: "/admin/add-favourite",
  adminProductApproval: "/admin/products-approval",
  adminProductApprovalForm:
    "/admin/products-approval/products-approval-form/:productId",
  adminManageCatalogue: "/admin/manage-catalogue",
  adminProductAddCards: "/admin/manage-add-product",
  adminManageCatalogueForm: "/admin/manage-catalogue/edit-product/:productId",
  adminAddProductForm: "/admin/manage-catalogue/add-product",
  adminModifyBulkProduct: "/admin/manage-catalogue/modify-bulk-product",
  adminPriceUpdate: "/admin/manage-catalogue/modify-bulk-product/price-update",
  adminGeneratePriceUpdateSheet:
    "/admin/manage-catalogue/modify-bulk-product/generate-price-update-sheet",
  adminDownloadManageCatalogue: "/admin/download-manage-catalogue",
  adminAddBulkProduct: "/admin/add-bulk-product",
  addBulkSupplierProductFromAdmin: "/admin/add-bulk-product/:supplierId",
  uploadSupplierProductsFromAdmin:
    "/admin/upload-supplier-products/:supplierId",
  adminEditBulkProduct: "/admin/manage-catalogue/edit-bulk-product",
  adminManageOrders: "/admin/manage-admin-orders",
  adminOrderDetails: "/admin/manage-admin-orders/order-details/:orderId",
  adminManageInvoices: "/admin/manage-admin-invoices",
  invoiceDetailsAdmin:
    "/admin/manage-admin-invoices/invoices-details/:invoiceId",
  buyerApprovalForm: "/admin/buyer-approval-form/:businessId",
  supplierApprovalForm: "/admin/supplier-approval-form/:businessId",
  buyerBusinessApprovalPage: "/admin/buyer-approval",
  supplierBusinessApprovalPage: "/admin/supplier-approval",
  productDetailsPageAdmin:
    "/admin/products-approval/product-details/:productId",
  productDetailsPageAdminFromCatalogue:
    "/admin/manage-catalogue/product-details/:productId",
  linkIndividualProduct: "/admin/link-product/:supplierId/:warehouseId",
  linkProduct: "/admin/link-product",
  adminReport: "/admin/reports",
  adminSpecialPricing: "/admin/special-pricing",
  AdminSpecialPricingRequest: "/admin/special-pricing/request",
  offlineSuppliers: "/admin/offline-suppliers",
  updateOfflineSupplier: "/admin/offline-suppliers/:customerId",
  adminCustomersList: "/admin/customers/list",
  createFinanceRequest: "/admin/create-finance-request",
  addBulkCart: "/admin/add-bulk-cart",
  addBulkOMS: "/admin/add-bulk-oms",
  adminPOS: "/admin/pos",
  posTypes: "/admin/pos/types",
  posRestaurants: "/admin/pos/types/restaurant/",
  posRetail: "/admin/pos/types/retail/",
  posLinkedById: "/admin/pos/:posId/types",
  posRestaurantDetails: "/admin/pos/:posId/types/restaurant/details",
  posRetailDetails: "/admin/pos/:posId/types/retail/details",

  // Buyer User Routes
  dashboard: "/buyer/dashboard",
  marketPlace: "/buyer/marketplace",
  buyerProductDetails: "/buyer/product-details/:productId",
  buyerBusinessSetupForm: "/buyer/setup-business",
  buyerOrdersListing: "/buyer/orders-listing",
  buyerLoadingScreen: "/buyer/loading-screen",
  buyerInvoices: "/buyer/manage-invoices",
  buyerInvoiceDetails: "/buyer/invoices-details/:invoiceId",
  buyerSpecialPricing: "/buyer/special-pricing",
  myCart: "/buyer/my-cart",
  placeOrder: "/buyer/place-order",
  subCategoryItemsListPage:
    "/buyer/marketplace/:categoryId/subcategory-items-list",
  ProductsListAndFiltersPage: "/buyer/marketplace/products-list",
  buyerPreferences: "/buyer/preferences",
  buyerAddNewSupplier: "/buyer/add-new-supplier",

  // Supplier User Routes
  supplierDashboard: "/supplier/dashboard",
  supplierOnboardinDashboard: "/supplier/onboarding-dashboard",
  businessSetupForm: "/supplier/setup-business",
  manageOrders: "/supplier/manage-orders/:orderId",
  productListingCatalogue: "/supplier/product-listinge-catalogue",
  orderListingCatalogue: "/supplier/order-listing",
  manageSupplierCatalogue: "/supplier/manage-catalogue",
  modifyBulkProduct: "/supplier/manage-catalogue/modify-bulk-product",
  downloadManageCatalogue: "/supplier/download-manage-catalogue",
  addIndividualProduct: "/supplier/catalogue/add-individual-product",
  addBulkProduct: "/supplier/add-bulk-product",
  editBulkProduct: "/supplier/manage-catalogue/edit-bulk-product",
  productDetailsPage: "/supplier/product-details",
  productDetailsPageSupplier: "/supplier/catalogue/product-details/:productId",
  supplierProductEditForm: "/supplier/catalogue/product-update/:productId",

  //  removed routes becuase reveal terms to supplier removed from the componentRoutes.tsx file and sideNav.tsx file
  inVoices: "/supplier/invoices",
  invoiceDetails: "/supplier/invoices-details/:invoiceId",
  supplierReport: "/supplier/report",
  // ------------------------------------------------------------------
  loadingScreen: "/supplier/loading-screen",
  referAFriend: "/supplier/refer-a-friend",
  supplierFullyLoadedDashboard: "/supplier/fully-loaded-dashboard",
  specialPricing: "/supplier/special-pricing",
  supplierSpecialPricingRequest: "/supplier/special-pricing/request",
  notifications: "/supplier/notifications",
  supplierPreferences: "/supplier/preferences",
});

export type RouteConfigKey = keyof typeof routeConfig;
